// export const MsalConfig = {
//   appId: 'a6867d33-3bf3-4b8b-bbf4-0eeb108dfb76',
//   redirectUri: 'https://vepeopleplus-staging.azurewebsites.net/dashboard',
//   scopes: ['user.read'],
//   authority:
//     'https://login.microsoftonline.com/e6fdbcc7-dcec-409f-8d1c-0eec6fa68f44',
// };

import {
  InteractionRequiredAuthError,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { getLocalStorageItem, setLocalStorage } from '../utils/common.util';

export const MsalConfig = {
  appId: '25bb0c61-3e74-4e5e-b391-f3a06b3a21a2',
  redirectUri: 'https://ve-peopleplus-staging-fe.azurewebsites.net/dashboard',
  authority: 'https://www.okta.com/saml2/service-provider/spfwavnfctvqcmunzmen',
};

export const getMsalInstance = () => {
  const config = getLocalStorageItem('config');
  if (!config || !config.clientId || !config.tenantId) {
    throw new Error('MSAL config missing');
  }

  const msalConfig = {
    auth: {
      clientId: config.clientId,
      authority: `https://login.microsoftonline.com/${config.tenantId}`,
      redirectUri: `${window.location.origin}/redirect-sso`,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  };

  return new PublicClientApplication(msalConfig);
};

// export const msalConfig = {
//   auth: {
//     clientId: '0f5433ed-7813-462c-994e-545d0a230a7a',
//     authority: 'https://login.microsoftonline.com/common',
//     redirectUri: `${window.location.origin}/redirect-sso`,
//     navigateToLoginRequestUrl: false, // prevent automatic nav
//   },
//   cache: {
//     cacheLocation: 'localStorage',
//     storeAuthStateInCookie: false,
//   },
// };

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'offline_access',
    'User.Read',
    // 'Chat.Read',
    // 'Team.ReadBasic.All',
    // 'Chat.ReadBasic',
    // 'Channel.ReadBasic.All',
    // 'ChannelMessage.Read.All',
    // 'Calendars.Read',
    // 'Calendars.ReadBasic',
    // 'OnlineMeetings.Read',
    // 'MailboxSettings.Read',
    // 'Calendars.ReadWrite',
  ],
};

// export const msalInstance = new PublicClientApplication(msalConfig);

export const getAccessToken = async (scope) => {
  const msalInstance = getMsalInstance();

  const account = msalInstance.getAllAccounts()[0];
  if (!account) {
    const popup = await msalInstance.acquireTokenPopup({
      scopes: safeParseScopeString(scope),
    });
    setLocalStorage('MSSO', popup);
    return popup.accessToken;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: safeParseScopeString(scope),
      account,
    });
    setLocalStorage('MSSO', response);
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      const popup = await msalInstance.acquireTokenPopup({
        scopes: safeParseScopeString(scope),
      });
      setLocalStorage('MSSO', popup);
      return popup.accessToken;
    }
    throw err;
  }
};

export const getCRMAccessToken = async (scope) => {
  const msalInstance = getMsalInstance();

  const account = msalInstance.getAllAccounts()[0];
  if (!account) {
    const popup = await msalInstance.acquireTokenPopup({
      scopes: safeParseScopeString(scope),
    });
    // setLocalStorage('MSSO', popup);
    return popup.accessToken;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: safeParseScopeString(scope),
      account,
    });
    // setLocalStorage('MSSO', response);
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      const popup = await msalInstance.acquireTokenPopup({
        scopes: safeParseScopeString(scope),
      });
      // setLocalStorage('MSSO', popup);
      return popup.accessToken;
    }
    throw err;
  }
};

function safeParseScopeString(str) {
  // Replace single quotes with double quotes
  let cleanStr = str.replace(/'/g, '"');

  // Remove trailing comma before the closing ]
  cleanStr = cleanStr.replace(/,\s*]/, ']');

  try {
    return JSON.parse(cleanStr);
  } catch (error) {
    console.error('Failed to parse scopes string:', error);
    return []; // return empty array as fallback
  }
}
